import React from "react";
import { useParams } from "react-router-dom";
// import employee from "../../../employee.json";
import "./EmployeeFormPage.css";
// import { findObjectUseCase } from "../../usecases/object";

function Profile() {
  const [employee, setEmployee] = React.useState([]);
  //   const { id } = useParams();
  const emp = employee[0];

  async function getEmp() {
    // const query = {
    //   where: {
    //     id: id,
    //   },
    // };
    // const response = await findObjectUseCase().execute("users", query);

    setEmployee([
      {
        username: "andrew.tamayo016@gmail.com",
        email: "francojohnc@gmail.com",
        firstName: "JOHN CARLO",
        middleName: "",
        lastName: "FRANCO",
        gender: "MALE",
        contactNumber: 9976086635,
        position: "OBSERVER",
        picture:
          "https://api.innque.com/v1/files/internal-mweeb/eeYM5MVV3jteHEX1GBEFdwZcxt9wRoHS_james.jpeg",
        id: "41e88438-a006-45fe-a33b-ef2017bc56ae",
        roles: [],
      },
    ]);
  }

  React.useEffect(() => {
    getEmp();
  }, []);

  console.log("emp", emp);

  if (!emp) {
    return <div className="container mt-5"></div>;
  }

  async function fetchImageAsBase64(imageUrl) {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        // reader.result is like "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ…"
        const base64data = reader.result.split(",", 2)[1];
        resolve(base64data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  const handleSaveContact = async (emp) => {
    const photoBase64 = await fetchImageAsBase64(emp.picture);
    const vCardData = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `N:${emp.lastName};${emp.firstName};;;`,
      `FN:${emp.firstName} ${emp.lastName}`,
      `TEL;TYPE=CELL:${emp.contactNumber}`,
      `EMAIL;TYPE=INTERNET:${emp.email}`,
      `ORG:MWeeb Inc.`,
      `PHOTO;ENCODING=BASE64;TYPE=JPEG:${photoBase64}`,
      "END:VCARD",
    ].join("\r\n"); // Important for compatibility

    const blob = new Blob([vCardData], { type: "text/vcard;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${emp.firstName}_${emp.lastName}.vcf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="business-card">
      {/* 1) Black header with logo & QR icon */}
      <div className="card-header">
        <img
          src="https://api.innque.com/v1/files/internal-mweeb/4JMJXvdTF1pjgIinHiMmwKbPwSqLAZDW_Logo-03_(1).png"
          alt="Company Logo"
          className="header-logo"
          height="100"
        />
        <i className="bi bi-qr-code header-qr text-dark" />
      </div>

      {/* 2) Avatar, overlapping the header/body */}
      <div className="avatar-wrapper">
        <img
          src={"/test.png"}
          alt={`${emp.firstName} ${emp.lastName}`}
          className="avatar"
        />
      </div>

      {/* 3) White body */}
      <div className="card-body">
        <h2 className="name">
          {emp.firstName} {emp.middleName} {emp.lastName}
        </h2>
        <p className="position">{emp.position}</p>
        <p className="tagline">Connect with me</p>

        {/* 4) Social icons */}
        <div className="socials">
          <a href={emp.facebook} target="_blank" rel="noreferrer">
            <i className="bi bi-facebook" />
          </a>
          <a href={emp.linkedIn} target="_blank" rel="noreferrer">
            <i className="bi bi-linkedin" />
          </a>
          <a
            href={`https://wa.me/${emp.contactNumber}`}
            target="_blank"
            rel="noreferrer"
          >
            <i className="bi bi-whatsapp" />
          </a>
        </div>

        {/* 5) Contact list */}
        <ul className="contact-list">
          <li>
            <a
              href={`tel:${emp.contactNumber}`}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
                padding: "8px 0",
                cursor: "pointer",
              }}
            >
              <i className="bi bi-telephone contact-icon" />
              <div className="contact-text" style={{ marginLeft: "12px" }}>
                <span className="value" style={{ fontWeight: 500 }}>
                  {emp.contactNumber}
                </span>
                <small
                  className="label"
                  style={{ display: "block", color: "#888" }}
                >
                  Mobile
                </small>
              </div>
            </a>
          </li>

          <li>
            <a
              href={`mailto:${emp.email}`}
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
                padding: "8px 0",
                cursor: "pointer",
              }}
            >
              <i className="bi bi-envelope contact-icon" />
              <div className="contact-text" style={{ marginLeft: "12px" }}>
                <span className="value" style={{ fontWeight: 500 }}>
                  {emp.email}
                </span>
                <small
                  className="label"
                  style={{ display: "block", color: "#888" }}
                >
                  Email Address
                </small>
              </div>
            </a>
          </li>

          <li>
            <a
              href={`https://mweeb.com`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
                padding: "8px 0",
              }}
            >
              <i className="bi bi-globe contact-icon" />
              <div className="contact-text" style={{ marginLeft: "12px" }}>
                <span className="value" style={{ fontWeight: 500 }}>
                  mweeb.com
                </span>
                <small className="label d-block" style={{ color: "#888" }}>
                  Website
                </small>
              </div>
            </a>
          </li>

          <li>
            <i className="bi bi-geo-alt contact-icon" />
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                "Unit 402, De Oro Building, Sierra Madre St., Brgy. Malamig, Mandaluyong City"
              )}`}
              className="text-decoration-none text-dark"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="contact-text">
                <span className="">
                  Unit 402, De Oro Building, Sierra Madre St., Brgy. Malamig,
                  Mandaluyong City
                </span>
                <p>
                  <small className="label">Address</small>
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>

      {/* 6) Footer buttons */}
      <div className="card-footer">
        <button className="btn-add" onClick={() => handleSaveContact(emp)}>
          Add to Contacts
        </button>
        <button className="btn-vcard">
          <i className="bi bi-person-plus" />
        </button>
      </div>
    </div>
  );
}

export default Profile;
